<template>
    <button class="app-icon-button focusable" @click="$emit('click')">
        <div class="app-icon-button__icon">
            <img :src="prototype.icon" :alt="prototype.title" />
        </div>
    </button>
</template>

<script>
    export default {
        name: 'app-icon-button',
        props: ['prototype'],
    };
</script>

<style scoped>
    .app-icon-button {
        display:flex;
        align-items: center;
        height:100%;
        border: 0;
        outline: 0;
        background: none;
        position: relative;
        padding: 0;
    }

    .app-icon-button:disabled {
        opacity: 0.3;
    }

    .app-icon-button:hover {
        cursor: pointer;
    }

    .app-icon-button:hover .app-icon-button__icon {
        opacity: .8;
    }

    .app-icon-button__icon {
        width: 24px;
        height: 24px;
    }

    .app-icon-button__icon img {
        width:100%;
        border-radius:25%;
        height:auto;
    }
</style>



// WEBPACK FOOTER //
// AppIconButton.vue?5fcf8941